import { GlobalService } from 'src/app/global.service';
import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ThemePalette, ProgressSpinnerMode } from '@angular/material';

@Component({
  selector: 'app-unique-route-wise-report',
  templateUrl: './unique-route-wise-report.component.html',
  styleUrls: ['./unique-route-wise-report.component.scss']
})
export class UniqueRouteWiseReportComponent implements OnInit {
  selected_date: any;
  selected_session_id: any;
  pdf_data: any;
  is_document_available: boolean = true;
  document_file: any = null;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  title: any;
  from_date: any;
  to_date: any;
  constructor(private httpService: HttpService, private dom: DomSanitizer, private global: GlobalService) {
    this.title = this.global._active_display_name;
  }

  getClicked() {
    let data_dict = {
      'from_date': this.from_date,
      'to_date': this.to_date,
    };
    console.log(data_dict);
    this.is_document_available = false;
    
    this.httpService.serveUniqueRouteWiseSaleAbstract(data_dict).subscribe((data) => {
      console.log(data);
      this.pdf_data = this.dom.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + data['pdf']);
      this.document_file = data;
      this.is_document_available = true;
    }, (error) => {
      this.is_document_available = true;
    });
  }
  

  downloadClicked() {
    const linkSource = 'data:application/pdf;base64,' + this.document_file['pdf'];
    const downloadLink = document.createElement("a");
    const fileName = this.document_file['file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  changeEvent() {
    this.document_file = null;
  }

  ngOnInit() {
  }

}
